export default __webpack_public_path__ + "static/media/desktop_add_new.c2311299.svg";